import { Navigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useUserLoginInfoContext } from 'authentication/authentication-outer/UserLoginInfo/UserLoginInfoContext';
import { hasStaleAuthCache, hasValidAuthSession } from 'helpers/authSession';
import { useLogoutUser } from 'helpers/logout';

const RootRedirect = () => {
  const userLoginInfo = useUserLoginInfoContext();
  const logout = useLogoutUser();
  const isAuthenticated = hasValidAuthSession(userLoginInfo);
  const didLogoutRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated && hasStaleAuthCache() && !didLogoutRef.current) {
      didLogoutRef.current = true;
      logout();
    }
    if (isAuthenticated) {
      didLogoutRef.current = false;
    }
  }, [isAuthenticated]);

  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
};

export default RootRedirect;
